import React, { useEffect, useMemo, useState } from 'react';
import { Modal,DatePicker } from 'rsuite';
import { laptopLink, paymentLink } from 'whealth-core-web/assets/images';
import Select2DropDown from '../common/Select2DropDown';
import CoreInputBox from '../CoreInputBox';
import { dateFormat, timeFormat, titlizeString } from '../Helper';
import useApiManager from 'networking/ApiManager';
import CommonAlert from '../CommonAlert';
import { copyIcon } from 'res/images';
import { checked } from 'whealth-core-web/res/images';
import { useCockpit } from 'whealth-core-web/hooks';
import { useNavigate, useLocation } from 'react-router-dom';
import CoreTextArea from '../CoreTextArea';
import { useDispatch } from 'react-redux';
import { setPatientActiveTab, setCrpMarkedShow } from 'redux/Slices';
import { set } from 'rsuite/esm/utils/dateUtils';

function RecordPayment(props) {
  const {
    isBabyMd,
    appointmentDetail,
    handleRecordPayment,
    open,
    statusItem,
    setOpen,
    errors,
    isClinicEnable,
    setErrors,
    userData,
    isNivanCare,
    setIsLoading,
    isShowAlert,
    setIsShowAlert,
    alertType,
    getPatientData,
  } = props;
  const ApiClient = useApiManager();
  const dispatch = useDispatch();
  const cockpit = useCockpit();
  const navigate = useNavigate();
  const location = useLocation();
  const [overflow, setOverflow] = useState(true);
  const [data, setData] = useState({});
  const [clinicalTeamList, setClinicalTeamList] = useState([]);
  const [payment, setPayment] = useState({
    id: null,
    short_url: null,
    status: null,
  });
  const [specialityNotes, setSpecialityNotes] = useState('');
  const [nextFollowupDate, setNextFollowupDate] = useState(null);
  const [notFirst,setNotFirst] = useState(0)
  
  const isCrp = appointmentDetail?.service?.title == 'crp';
  const isConsult = appointmentDetail?.service?.id == 1;

  // Function to mask phone number for doctor role - show first 2 and last 3 digits
  const maskPhoneNumber = (phone) => {
    if (userData?.role === 'doctor' || userData?.role === 'doctor_pms') {
      if (!phone) return '';
      const phoneStr = phone.toString();
      if (phoneStr.length < 5) return phoneStr;

      const firstTwo = phoneStr.substring(0, 2);
      const lastThree = phoneStr.substring(phoneStr.length - 3);
      const maskedMiddle = '*'.repeat(phoneStr.length - 5);

      return `${firstTwo}${maskedMiddle}${lastThree}`;
    }

    return phone;
  };
  console.log('appointmentDetail', appointmentDetail?.service?.title);
  console.log('RecordPayment props: ', props);
  useEffect(() => {
    setErrors({});
  }, [open]);
  useEffect(() => {
    if (appointmentDetail?.id) {
      setData({
        payment_type: appointmentDetail?.payment_type,
        payment_mode: appointmentDetail?.payment_mode,
        payment_from: appointmentDetail?.payment_from,
        amount: appointmentDetail?.appointment_fee - appointmentDetail?.amount,
        // amount:
        //   appointmentDetail?.payment_type == 'partially_paid' ? appointmentDetail?.appointment_fee - appointmentDetail?.amount : appointmentDetail?.amount,
        patient_attendance_status: appointmentDetail?.patient_attendance_status,
        affluence_level: appointmentDetail?.affluence_level,
        payment_with_id: appointmentDetail?.payment_with?.id,
        payment_with_source: appointmentDetail?.payment_with_source,
        insurance_category: appointmentDetail?.user?.insurance_category,
        insurance_type: appointmentDetail?.user?.insurance_type,
        next_followup_date: appointmentDetail?.user?.next_followup_date,
      });
      // notes_by_speciality
      if (appointmentDetail?.notes_by_speciality) {
        setSpecialityNotes(appointmentDetail?.notes_by_speciality);
      }
    } else {
      setData({});
    }
  }, [appointmentDetail]);

  useEffect(() => {
    if (isNivanCare && data?.payment_with_source == 'AdminProfile') {
      getDoctor();
    }
  }, [data?.payment_with_source]);
  useEffect(() => {
    var id = 1234
    if (appointmentDetail?.user?.id && data?.patient_attendance_status == 'show') {
      setIsLoading(true);
      let params = { user_id : appointmentDetail?.user?.id };
      ApiClient.checkAppointment(params,id)
        .then((res) => {
          setIsLoading(false);
          setNotFirst(res.data.not_first)
          // setClinicalTeamList(res.data);
        })
        .catch((err) => {
          setIsLoading(false);
        });
    }
  }, [data?.patient_attendance_status]);

  

  const validateRecordPayment = (data) => {
    if (isCrp || data?.patient_attendance_status == 'no_show') {
      return true;
    }
    if (!data?.insurance_category) {
      setErrors((prev) => ({ ...prev, insurance_category: 'Insurance Category is required' }));
      return false;
    }
    if (isConsult && data?.patient_attendance_status == 'show' && (data?.affluence_level == '' || data?.affluence_level == null)){
      setErrors((prev) => ({ ...prev, affluence_level: 'Affluence Level is required' }));
      return false;
    }
    if(notFirst && isConsult && data?.patient_attendance_status == 'show' && (data?.next_followup_date == null || data?.next_followup_date == '')){
      setErrors((prev) => ({ ...prev, next_followup_date: 'Next follow up date is required' }));
      return false;

    }
    if (data?.insurance_category === 'Govt' && !data?.insurance_type) {
      setErrors((prev) => ({ ...prev, insurance_type: 'Insurance Type is required' }));
      return false;
    }
    return true;
  };

  const recordPaymentAndReload = (id, userId, data) => {
    setIsLoading(true);
    if (!validateRecordPayment(data)) {
      setIsLoading(false);
      return;
    }
    // If it's a CRP appointment, include the speciality notes
    const payloadData = isCrp ? { ...data, notes_by_speciality: specialityNotes, is_crp_appointment: true } : data;
    console.log('payloadData',data)
    ApiClient.recordPayment(id, payloadData)
      .then(() => {
        if (isCrp) {
          dispatch(setCrpMarkedShow(true));
        }
        setIsLoading(false);
        setOpen(false);
        dispatch(setPatientActiveTab('timeline'));
        if (location.pathname !== '/appointment') {
          navigate(`/patient/${userId}/dashboard`);
        } else {
          window.location.reload();
        }
        getPatientData();
      })
      .catch((err) => {
        setIsLoading(false);
        console.error('Error recording payment:', err);
      });
  };

  const remaining = useMemo(() => {
    return appointmentDetail.payment_details?.reduce((acc, item) => {
      const paid = item.payment_status === 'paid';
      return acc - (paid ? item.amount : 0);
    }, appointmentDetail.appointment_fee);
  }, [appointmentDetail]);

  const calculateAgeInMonths = (dob) => {
    const currentDate = new Date();
    const birthDate = new Date(dob);
    const months = (currentDate?.getFullYear() - birthDate?.getFullYear()) * 12 + (currentDate?.getMonth() - birthDate?.getMonth());
    return months;
  };
  const ageInMonths = calculateAgeInMonths(appointmentDetail?.user?.date_of_birth);

  const renderRecordHeader = () => {
    return (
      <div className='recordPayment-top-box d-flex justify-content-between align-items-start mb-3'>
        <div className='w-100'>
          <div className='head'>Appointment Summary</div>
          <div className='tileName mt-2'>
            {appointmentDetail?.user?.full_name} ({appointmentDetail?.user?.gender && appointmentDetail?.user?.gender[0]?.toUpperCase()},{' '}
            {appointmentDetail?.user?.date_of_birth && isBabyMd && ` ${ageInMonths} M`}
            {!isBabyMd && appointmentDetail?.user?.age})
          </div>
          <p>Ph: {maskPhoneNumber(appointmentDetail?.user?.phone)}</p>
          <p className='mt-2'>
            <strong>
              {dateFormat(appointmentDetail?.consult_datetime)}, {timeFormat(appointmentDetail?.consult_datetime)} -{' '}
              {timeFormat(appointmentDetail?.consult_end_datetime)}
            </strong>{' '}
            <br />
            With {appointmentDetail?.consultant?.full_name} <br />
            {appointmentDetail?.service?.title}
            {appointmentDetail?.complimentary_prc && (
              <span style={{ color: '#28a745', fontWeight: 700 }}> (CP)</span>
            )}{' '}
            <br />
            At Clinic {appointmentDetail?.location?.name} <br />
            <div className='d-flex'>
              {' '}
              Total Fee :
              <span
                class='material-icons-outlined'
                style={{
                  fontSize: '13px',
                  paddingTop: '4px',
                  paddingLeft: '4px',
                }}
              >
                currency_rupee
              </span>
              {appointmentDetail?.appointment_fee || '0.00'}
            </div>
            {/* <div className='d-flex'>
              {' '}
              Remaining Fee :
              <span
                class='material-icons-outlined'
                style={{
                  fontSize: '13px',
                  paddingTop: '4px',
                  paddingLeft: '4px',
                }}
              >
                currency_rupee
              </span>
              {remaining}
            </div> */}
          </p>
          {appointmentDetail?.payment_details?.length > 0 && (
            <table style={{ marginTop: '10px' }} className='table table-bordered w-100' cellspacing='5'>
              <thead>
                <tr>
                  <th scope='col' className='text-center'>
                    Amount
                  </th>
                  <th scope='col' className='text-center'>
                    Payment Mode
                  </th>
                  <th scope='col' className='text-center'>
                    Status
                  </th>
                  <th scope='col' className='text-center'>
                    Payment type
                  </th>
                </tr>
              </thead>
              <tbody>
                {appointmentDetail?.payment_details?.map((payment) => {
                  const paid = payment.payment_status === 'paid';
                  return (
                    <tr className='center' key={payment.id}>
                      <td className='capitalize text-center'>{payment?.amount === '' ? '0.00' : payment?.amount}</td>
                      <td className='capitalize text-center'>{payment.payment_mode || 'N/A'}</td>
                      {/* <td>
                        {paid ? (
                          'Payment Complete'
                        ) : !!payment.payment_url ? (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <a href={payment.payment_url} target='_blank'>
                              {payment.payment_url}
                            </a>
                            <img
                              onClick={(e) => {
                                e.preventDefault();
                                navigator.clipboard.writeText(payment.payment_url);
                                e.target.src = checked;
                                // setTimeout(() => {
                                //   e.target.src = copyIcon;
                                // }, 1000);
                              }}
                              style={{
                                width: '20px',
                                height: '20px',
                                marginLeft: '10px',
                                cursor: 'pointer',
                              }}
                              src={copyIcon}
                              alt='copy-icon'
                            ></img>
                          </div>
                        ) : (
                          'N/A'
                        )}
                      </td> */}
                      <td className='capitalize text-center'>
                        {paid ? (
                          'Paid'
                        ) : (
                          <>
                            Pending{' '}
                            <a href={payment.payment_url} target='_blank'>
                              (Pay Now)
                            </a>
                          </>
                        )}
                      </td>
                      <td className='capitalize text-center'>{payment.payment_type == 'paid' ? 'Fully Paid' : titlizeString(payment.payment_type) || 'N/A'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
          {/* {appointmentDetail?.payment_mode && (
            <div className='d-flex flex-column justify-content-start mt-2 '>
              <span className='consultationTitle d-flex'>
                <img src={paymentLink} />
                <div className='d-flex'>
                  {appointmentDetail?.appointment_fee !== appointmentDetail?.amount ? 'Partially Payment of' : 'Payment of'}{' '}
                  <span
                    class='material-icons-outlined'
                    style={{
                      fontSize: '14px',
                      paddingTop: '4px',
                      paddingLeft: '4px',
                    }}
                  >
                    currency_rupee
                  </span>{' '}
                  {appointmentDetail?.amount}
                </div>
              </span>
              <span className='consultationTitle d-flex'>
                <img src={laptopLink} /> {appointmentDetail?.payment_mode?.charAt(0)?.toUpperCase() + appointmentDetail?.payment_mode?.slice(1)}
              </span>
            </div>
          )} */}
        </div>
        {/* <div className='d-flex justify-content-center align-items-center popover-btn'>
              <span class='material-icons-outlined'>mode_edit_outline</span> Edit
            </div> */}
      </div>
    );
  };

  const getDoctor = () => {
    setIsLoading(true);
    let params = { can_accept_payment: true, remove_inactive_admins: true };
    ApiClient.getSearchTeam(params)
      .then((res) => {
        setIsLoading(false);
        setClinicalTeamList(res.data);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const generatePaymentLink = ({ user, user_order_id }) => {
    ApiClient.generatePaymentLink(user.id, user_order_id, { amount: data?.amount }).then((res) => {
      setPayment(res.data.data);
    });
  };

  const refreshPaymentLink = (id) => {
    ApiClient.refreshPaymentLink(payment.id).then((res) => {
      setPayment(res.data.data);
    });
  };

  return (
    <Modal
      className='recordPayment'
      backdrop='static'
      overflow={overflow}
      open={open}
      onClose={() => {
        // setData({});
        setPayment({
          id: null,
          short_url: null,
          status: null,
        });
        setOpen(false);
      }}
    >
      <Modal.Header>
        <Modal.Title className='text-center modalTitle'>{isCrp ? 'Mark Show' : '**Record Payment**'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={`${isShowAlert ? 'mt-5' : ''}`}>
          <CommonAlert isShowAlert={isShowAlert} alertType={alertType} setIsShowAlert={setIsShowAlert} />
        </div>
        <div className='appontmentModle-body d-flex flex-column'>
          {renderRecordHeader()}
          <div className='mb-2'>
            {/* scheduled */}
            <Select2DropDown
              retuired
              disabled={
                !(appointmentDetail?.appointment_type == 'prepaid' &&
                  appointmentDetail?.patient_attendance_status != 'show') &&
                appointmentDetail?.patient_attendance_status !== 'booked' &&
                (appointmentDetail?.patient_attendance_status == 'show' ||
                  appointmentDetail?.patient_attendance_status == 'no_show' ||
                  (appointmentDetail?.channel?.toLowerCase() != 'web' && (appointmentDetail?.payment_type == 'paid' ||
                  appointmentDetail?.payment_type == 'free' )))
              }
              label={'Patient Attendance'}
              data={
                isCrp
                  ? [{ title: 'Show', id: 'show' }]
                  : [
                      { title: 'Show', id: 'show' },
                      { title: 'No Show', id: 'no_show' },
                    ]
              }
              showMSG={errors?.patient_attendance_status}
              value={data?.patient_attendance_status || ''}
              onSelect={(val) => {
                if (appointmentDetail?.patient_attendance_status == 'booked') {
                  setData((prev) => ({ ...prev, patient_attendance_status: val }));
                } else {
                  // For web channel, preserve payment_type and related fields
                  {console.log(appointmentDetail)}
                  if ((appointmentDetail?.channel?.toLowerCase() === 'web' || appointmentDetail?.appointment_type?.toLowerCase() === 'prepaid' ) && appointmentDetail?.payment_type) {
                    setData({
                      patient_attendance_status: val,
                      insurance_category: appointmentDetail?.user?.insurance_category,
                      insurance_type: appointmentDetail?.user?.insurance_type,
                      affluence_level: appointmentDetail?.affluence_level,
                      payment_type: appointmentDetail?.payment_type,
                      payment_mode: appointmentDetail?.payment_mode,
                      payment_from: appointmentDetail?.payment_from,
                      amount: appointmentDetail?.payment_type == 'partially_paid' 
                        ? appointmentDetail?.appointment_fee - appointmentDetail?.amount 
                        : appointmentDetail?.amount,
                      payment_with_id: appointmentDetail?.payment_with?.id,
                      payment_with_source: appointmentDetail?.payment_with_source,
                    });
                  } else {
                    setData({
                      patient_attendance_status: val,
                      insurance_category: appointmentDetail?.user?.insurance_category,
                      insurance_type: appointmentDetail?.user?.insurance_type,
                      affluence_level: appointmentDetail?.affluence_level,
                    });
                  }
                }
              }}
            />
          </div>
          {appointmentDetail?.service?.id == 1 && data?.patient_attendance_status == 'show' && notFirst ?
          (
            <div className='mb-2'>
                <div className={`w-100  position-relative`} id='patientDatePickerContainer'>
                  <div>
                    <label class='inputlabel'>
                      <span className='requiredInput'> * </span>Next Follow up Date
                    </label>
                  </div>
                  <DatePicker
                    className='w-100'
                    container={() => document.getElementById('patientDatePickerContainer')}
                    placeholder='Next Follow up Date'
                    format='yyyy-MM-dd HH:mm'
                    onClean={() => setData((prev) => ({ ...prev, next_followup_date: null }))}
                    disabledDate={(date) => {
                      if (new Date(date) < new Date().setHours(0, 0, 0)) {
                        return true;
                      } else {
                        return false;
                      }
                    }}
                    value={data?.next_followup_date ? new Date(data?.next_followup_date) : null}
                    onSelect={(data) => {
                      setData((prev) => ({ ...prev, next_followup_date: data }));
                    }}
                  />
                  {errors.next_followup_date && <div className='inputMsg'>{errors.next_followup_date}</div>}
            </div>
            </div>
          )
          :null
          }
          {data?.patient_attendance_status == 'show' && isCrp ? (
            <div className='mb-2'>
              <CoreTextArea
                //retuired
                label={'Notes by Speciality'}
                placeholder={'Enter notes for this session (max 255 characters)'}
                value={specialityNotes}
                setValue={(val) => {
                  // Limit to 255 characters
                  if (val.length <= 255) {
                    setSpecialityNotes(val);
                  }
                }}
                rows={4}
                maxLength={255}
              />
              <div style={{ marginTop: '5px', textAlign: 'right', fontSize: '12px', color: specialityNotes.length > 230 ? '#ff4d4f' : '#888' }}>
                {specialityNotes.length}/255 characters
              </div>
            </div>
          ) : null}
          {(data?.patient_attendance_status && data?.patient_attendance_status != 'no_show' && data?.patient_attendance_status != 'arrived' && !isCrp) ||
          (isBabyMd && statusItem?.id == 'show' && !isCrp) ? (
            <div className='mb-2'>
          {console.log("affluence_level",data)}
              <Select2DropDown
                    disabled={!!appointmentDetail?.affluence_level}
                    retuired
                    label={'Affluence Level'}
                    data={[
                      { title: 'High', id: 'High' },
                      { title: 'Medium', id: 'Medium' },
                      { title: 'Low', id: 'Low' },
                    ]}
                    showMSG={errors?.affluence_level}
                    value={data?.affluence_level ? data?.affluence_level : appointmentDetail?.affluence_level ? appointmentDetail?.affluence_level : ''}
                    onSelect={(val) => {
                      setData((prevData) => ({
                        ...prevData,
                        affluence_level: val,
                      }));
                    }}
                  />
              <Select2DropDown
                disabled={appointmentDetail?.payment_type}
                retuired
                label={'Payment Type'}
                data={[
                  { title: 'Free', id: 'free' },
                  { title: 'Fully Paid', id: 'paid' },
                  { title: 'Partially Paid', id: 'partially_paid' },
                ]}
                showMSG={errors?.payment_type}
                value={data?.payment_type || appointmentDetail?.payment_type || ''}
                onSelect={(val) => {
                  setData((prev) => ({
                    ...prev,
                    payment_type: val,
                    patient_attendance_status: prev?.patient_attendance_status,
                    amount: val == 'paid' ? appointmentDetail?.appointment_fee : null,
                  }));
                }}
              />
              
              {(data?.payment_type || appointmentDetail?.channel?.toLowerCase() == 'web' || appointmentDetail?.appointment_type?.toLowerCase() == 'prepaid') && (
                <>
                  <Select2DropDown
                    // disabled={appointmentDetail?.user?.insurance_category}
                    retuired
                    label={'Insurance Category'}
                    data={[
                      { title: 'Retail', id: 'Retail' },
                      { title: 'Corporate', id: 'Corporate' },
                      { title: 'Govt', id: 'Govt' },
                      { title: 'Cash', id: 'Cash' },
                      { title: 'NA', id: 'NA' },
                    ]}
                    showMSG={errors?.insurance_category}
                    value={data?.insurance_category || ''}
                    onSelect={(val) => {
                      setData((prevData) => ({
                        ...prevData,
                        insurance_category: val,
                      }));
                    }}
                  />
                  {data?.insurance_category && data?.insurance_category === 'Govt' && (
                    <Select2DropDown
                      // disabled={appointmentDetail?.user?.insurance_type}
                      retuired
                      label={'Insurance Type'}
                      data={[
                        { title: 'CGHS', id: 'CGHS' },
                        { title: 'DGHS', id: 'DGHS' },
                        { title: 'DJB', id: 'DJB' },
                        { title: 'ECHS', id: 'ECHS' },
                        { title: 'ESIC', id: 'ESIC' },
                        { title: 'Ayushman', id: 'Ayushman' },
                        { title: 'MCD', id: 'MCD' },
                      ]}
                      showMSG={errors?.insurance_type}
                      value={data?.insurance_type || ''}
                      onSelect={(val) => {
                        setData((prevData) => ({
                          ...prevData,
                          insurance_type: val,
                        }));
                      }}
                    />
                  )}
                </>
              )}
            </div>
          ) : null}
          {data?.patient_attendance_status != 'no_show' && (data?.payment_type == 'paid' || data?.payment_type == 'partially_paid') ? (
            <>
              <div className='mb-2'>
                <Select2DropDown
                  retuired
                  disabled={appointmentDetail?.payment_type == 'paid' || appointmentDetail?.payment_type == 'free'}
                  label={'Payment Mode'}
                  data={[
                    { title: 'Cash', id: 'cash' },
                    { title: 'Online', id: 'online' },
                  ]}
                  showMSG={errors?.payment_mode}
                  value={data?.payment_mode || ''}
                  onSelect={(val) => {
                    delete data?.payment_from;
                    setData((prev) => ({ ...prev, payment_mode: val }));
                  }}
                />
              </div>
              {data?.payment_mode == 'online' ? (
                <div className='mb-2'>
                  <Select2DropDown
                    retuired
                    disabled={appointmentDetail?.payment_type == 'paid' || appointmentDetail?.payment_type == 'free'}
                    showMSG={errors?.payment_from}
                    label={'Payment From'}
                    data={[
                      { title: 'UPI', id: 'upi' },
                      { title: 'PoS', id: 'pos' },
                      { title: 'Payment Link', id: 'payment_link' },
                      { title: 'Bank Transfer', id: 'bank_transfer' },
                    ]}
                    value={data?.payment_from || ''}
                    onSelect={(val) => setData((prev) => ({ ...prev, payment_from: val }))}
                  />
                </div>
              ) : null}

              <div className='mb-2'>
                <Select2DropDown
                  disabled={appointmentDetail?.payment_type == 'paid' || appointmentDetail?.payment_type == 'free'}
                  retuired
                  data={
                    userData?.role == 'ee'
                      ? [{ title: 'Nivaan Clinic', id: 'NivaanClinic' }]
                      : isNivanCare && isClinicEnable
                      ? [
                          { title: 'Clinical Team', id: 'AdminProfile' },
                          { title: 'Nivaan Clinic', id: 'NivaanClinic' },
                          { title: 'Clinic', id: 'Location' },
                        ]
                      : isClinicEnable
                      ? [
                          { title: 'Partner Hospital', id: 'Location' },
                          { title: 'Doctor', id: 'AdminProfile' },
                        ]
                      : [{ title: 'Doctor', id: 'AdminProfile' }]
                  }
                  onSelect={(_id, _obj) => {
                    setData((prev) => ({
                      ...prev,
                      payment_with_source: _obj?.id,
                      payment_with_id:
                        _obj?.id == 'AdminProfile' && !isNivanCare
                          ? appointmentDetail?.consultant?.id
                          : _obj?.id == 'Location'
                          ? appointmentDetail?.location?.id
                          : null,
                    }));
                  }}
                  value={data?.payment_with_source || ''}
                  showMSG={errors?.payment_with_source}
                  searchable={false}
                  style={{ width: '100%' }}
                  placeholder='Payment With'
                  label='Payment With'
                />
              </div>
              {/* {data?.payment_with_source == 'AdminProfile' ? (
                <div className='mb-2'>
                  <Select2DropDown
                    retuired
                    data={[appointmentDetail?.consultant]}
                    onSelect={(_id, _obj) => {
                      setData({ ...data, payment_with_id: _obj?.id });
                    }}
                    value={data?.payment_with_id}
                    showMSG={errors?.payment_with_id}
                    labelKey={'full_name'}
                    searchable={false}
                    style={{ width: '100%' }}
                    placeholder='With'
                    label='With'
                  />
                </div>
              ) : null}
              {data?.payment_with_source == 'Location' && appointmentDetail?.location ? (
                <div className='mb-2'>
                  <Select2DropDown
                    retuired
                    data={[appointmentDetail?.location]}
                    onSelect={(_id, _obj) => {
                      setData({ ...data, payment_with_id: _obj?.id });
                    }}
                    value={data?.payment_with_id}
                    showMSG={errors?.payment_with_id}
                    labelKey={'name'}
                    searchable={false}
                    style={{ width: '100%' }}
                    placeholder='With'
                    label='With'
                  />
                </div>
              ) : null} */}
              {data?.payment_with_source == 'AdminProfile' && isNivanCare ? (
                <div className='mb-2'>
                  <Select2DropDown
                    retuired
                    disabled={appointmentDetail?.payment_type == 'paid' || appointmentDetail?.payment_type == 'free'}
                    data={clinicalTeamList}
                    onSelect={(_id, _obj) => {
                      setData((prev) => ({ ...prev, payment_with_id: _obj?.id }));
                    }}
                    value={data?.payment_with_id}
                    showMSG={errors?.payment_with_id}
                    labelKey={'full_name'}
                    searchable={true}
                    style={{ width: '100%' }}
                    placeholder='Clinical Team'
                    label='Clinical Team'
                  />
                </div>
              ) : null}

              <div className='mb-2'>
                {appointmentDetail?.amount ?
                <>
                  <CoreInputBox
                    disabled={true}
                    retuired
                    validateNumbers
                    validateZero
                    validatedecimal
                    label={'Paid Amount'}
                    placeholder={'Paid Amount'}
                    showMSG={errors?.amount}
                    value={appointmentDetail?.amount || ''}
                    // setValue={(val) => setData((prev) => ({ ...prev, amount: val != '' ? Number(val) : null }))}
                  />
                  <CoreInputBox
                  disabled={data?.payment_type == 'paid' || appointmentDetail?.payment_type == 'paid' || appointmentDetail?.payment_type == 'free'}
                  retuired
                  validateNumbers
                  validateZero
                  validatedecimal
                  label={'Remaining Amount'}
                  placeholder={'Remaining Amount'}
                  showMSG={errors?.amount}
                  value={
                    (appointmentDetail.appointment_fee - appointmentDetail.amount).toString() 
                  }
                  setValue={(val) => setData((prev) => ({ ...prev, amount: val != '' ? Number(val) : null }))}
                />
                </>
                
                : 
                <CoreInputBox
                  disabled={data?.payment_type == 'paid' || appointmentDetail?.payment_type == 'paid' || appointmentDetail?.payment_type == 'free'}
                  retuired
                  validateNumbers
                  validateZero
                  validatedecimal
                  label={'Amount Paid'}
                  placeholder={'Amount Paid'}
                  showMSG={errors?.amount}
                  value={data?.amount?.toString() || ''}
                  setValue={(val) => setData((prev) => ({ ...prev, amount: val != '' ? Number(val) : null }))}
                />
                }
                
                
              </div>
            </>
          ) : null}
          {data?.payment_with_source ? (
            <div>
              <label>
                Billed To :{' '}
                {data?.payment_with_source == 'AdminProfile' || data?.payment_with_source == 'NivaanClinic'
                  ? appointmentDetail?.user?.full_name
                  : data?.payment_with_source == 'Location'
                  ? appointmentDetail?.location?.name
                  : null}
              </label>
            </div>
          ) : null}
          {cockpit?.show_generate_payment &&
            data?.payment_mode === 'online' &&
            (!!payment.id ? (
              <div
                className='mb-2 mt-3'
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                {/* add hypher link for payment  */}
                <div>
                  <a href={payment.short_url} target='_blank'>
                    {payment.short_url}
                  </a>
                  <img
                    onClick={(e) => {
                      e.preventDefault();
                      navigator.clipboard.writeText(payment.short_url);
                      e.target.src = checked;
                      // setTimeout(() => {
                      //   e.target.src = copyIcon;
                      // }, 1000);
                    }}
                    style={{
                      width: '20px',
                      height: '20px',
                      marginLeft: '10px',
                      cursor: 'pointer',
                    }}
                    src={copyIcon}
                    alt='copy-icon'
                  ></img>
                </div>
                <div>
                  <span>Payment Status: {payment.status}</span>
                  <button
                    style={{
                      backgroundColor: 'green',
                      color: 'white',
                      padding: '5px 10px',
                      borderRadius: '5px',
                      marginLeft: '10px',
                    }}
                    onClick={() => refreshPaymentLink()}
                  >
                    Refresh
                  </button>
                </div>
              </div>
            ) : (
              <div className='mb-2 mt-3'>
                <div className='d-flex justify-content-between gap-10 schedulButton' onClick={() => generatePaymentLink(appointmentDetail)}>
                  <div className='reusableBtnActive  reusableBtn  w-100' style={{ backgroundColor: '#D2ECE4', color: 'green' }}>
                    Generate Payment Link
                  </div>
                </div>
              </div>
            ))}

          {data?.patient_attendance_status && !['show', 'no_show'].includes(appointmentDetail?.patient_attendance_status) ? (
            <div className='mb-2 mt-3'>
              <div
                className='d-flex justify-content-between gap-10 schedulButton'
                onClick={() => recordPaymentAndReload(appointmentDetail?.id, appointmentDetail?.user?.id, data)}
              >
                <div className='reusableBtnActive reusableBtn w-100'>{isCrp ? 'Mark Show' : 'Record Payment'}</div>
              </div>
            </div>
          ) : null}

          {/* {appointmentDetail?.patient_attendance_status == 'booked' ||
          (data?.patient_attendance_status && data?.patient_attendance_status != 'no_show' && appointmentDetail?.payment_type != 'paid' && appointmentDetail?.payment_type != 'free') ? (
            <div className='mb-2 mt-3'>
              <div className='d-flex justify-content-between gap-10 schedulButton' onClick={() => recordPaymentAndReload(appointmentDetail?.id, appointmentDetail?.user?.id, data)}>
                <div className='reusableBtnActive reusableBtn w-100'>{isCrp ? 'Mark Show' : 'Record Payment'}</div>
              </div>
            </div>
          ) : null} */}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default RecordPayment;
